import * as keyset from 'i18n/DraftControlPanel';

import { DraftStatus } from '../../model/draft';

type TStatusKeys = Record<DraftStatus, '' | keyof (typeof keyset)['en']>;

const DEFAULT_STATUS_DESCRIPTION_KEYS: TStatusKeys = {
    [DraftStatus.InDevelopment]: 'desc-in-dev',
    [DraftStatus.ReviewRequested]: 'desc-in-review',
    [DraftStatus.ReviewApproved]: 'desc-approved',
    [DraftStatus.DeployRequested]: 'desc-deploy',
    [DraftStatus.ReviewCancelled]: '',
    [DraftStatus.ReviewRejected]: '',
    [DraftStatus.DeployRejected]: '',
    [DraftStatus.TestRequired]: '',
    [DraftStatus.MeetingApproval]: '',
    [DraftStatus.WaitingForTesting]: '',
    [DraftStatus.AppScanRequested]: 'desc-in-review',
    [DraftStatus.AppScanRequestedAfterModeration]: 'desc-in-review',
    [DraftStatus.DevicesTesting]: '',
    [DraftStatus.DevicesTestingCompleted]: '',
};

export const smartHomeDescriptionsKeys: TStatusKeys = {
    ...DEFAULT_STATUS_DESCRIPTION_KEYS,
    [DraftStatus.InDevelopment]: 'sh-desc-in-dev',
    [DraftStatus.ReviewRequested]: 'sh-desc-in-review',
    [DraftStatus.MeetingApproval]: 'sh-desc-meeting',
    [DraftStatus.WaitingForTesting]: 'sh-desc-waiting-for-test',
    [DraftStatus.DevicesTesting]: 'sh-desc-devices-testing',
    [DraftStatus.DevicesTestingCompleted]: 'sh-desc-testing-complete',
    [DraftStatus.ReviewApproved]: 'sh-desc-approved',
};

export const smartHomeDescriptionsAiredKeys: TStatusKeys = {
    ...DEFAULT_STATUS_DESCRIPTION_KEYS,
    [DraftStatus.InDevelopment]: 'sh-desc-in-dev',
    [DraftStatus.ReviewRequested]: 'sh-desc-in-review',
    [DraftStatus.MeetingApproval]: 'sh-desc-meeting',
    [DraftStatus.WaitingForTesting]: 'sh-desc-waiting-for-test',
    [DraftStatus.DevicesTesting]: 'sh-desc-devices-testing',
    [DraftStatus.DevicesTestingCompleted]: 'sh-desc-testing-complete',
    [DraftStatus.ReviewApproved]: 'sh-desc-approved',
};
